import styled from 'styled-components';
import RoomServiceSvg from '../../assets/amenities/room-service.svg';

const RoomServiceIcon = styled(RoomServiceSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default RoomServiceIcon;
